
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { TCategory, TStep } from "@/models/questionnaire";
import { API_ROUTES } from "@/utils/API";
import { SMQuestionnaire, SMUser } from "@/store";
import ProfileRow from "@/components/DetailsSummaryPage/components/ProfileRow.vue";

@Component({
  components: { ProfileRow },
})
export default class EmployeeDetailsSummaryPage extends Vue {
  @Prop({ type: Boolean, default: true }) readonly canEdit!: boolean;

  parsedFlows: TCategory[] = [];

  mounted() {
    this.getEmployeeFlow();
  }

  get isEditable() {
    if (SMUser.isExpert) return true;

    return !SMUser.isComplianceBlocked && this.canEdit;
  }

  get employeeId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  get endpoint() {
    const { companyId, employeeId: id } = this;

    if (!id) return "";

    if (companyId) return API_ROUTES.EXPERT_COMPANIES_PROFILE_EMPLOYEE(companyId, id);

    return API_ROUTES.COMPLIANCE_PROFILE_EMPLOYEE(id);
  }

  async getEmployeeFlow() {
    if (!this.endpoint) return;

    const { alias } = this.$route.meta;

    const { data } = await this.axios.get<TCategory[]>(this.endpoint, {
      params: { alias },
    });

    if (!data) return;

    this.parsedFlows = data;
  }

  getStepAnswerBlocks(step: TStep) {
    return step?.question?.answer_blocks ?? [];
  }

  getStepLabel(step: TStep) {
    return step?.question?.show_label && step?.question?.label;
  }

  emitEdit(payload: { caseId: number; stepId: number; type: string }) {
    this.$emit("edit", {
      ...payload,
      target_user_id: this.employeeId,
    });
  }

  get dataIsEdited() {
    return SMQuestionnaire.lastUpdatedStep;
  }

  @Watch("dataIsEdited", { deep: true, immediate: true })
  dataIsEditedChanged() {
    this.getEmployeeFlow();
  }
}
